import React from "react"
import DataGridTable from "../../../../components/Table/data-grid-table"
import {Box, Grid, Paper} from "@mui/material"
import PropTypes from "prop-types"
import ButtonWithIcon from "../../../../components/Button/Button"
import {ReactComponent as DownloadIcon} from "src/v2/assets/icons/download-icon.svg"

const TabelaDownloadArquivo = ({rows}) => {

    const renderDownloadButton = (params) => (
        <Grid container spacing={2}>
            <Grid item>
                <ButtonWithIcon
                    size={"md"}
                    icon={<DownloadIcon/>}
                    onClick={() => {
                        const {path, arquivo} = params.row || {}

                        const link = document.createElement("a")
                        link.href = path
                        link.download = arquivo
                        link.click()
                    }}
                >Download</ButtonWithIcon>
            </Grid>
        </Grid>
    )

    const renderOpenFile = (params) => {
        const {path, arquivo} = params.row || {}

        return (
            <a
                href={path}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    color: "inherit",
                    // textDecoration: "none",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 6,
                }}
            >
                {arquivo || "Abrir arquivo"}
            </a>
        )
    }

    const columns = [
        {
            field: "arquivo",
            headerName: "Arquivo",
            minWidth: 200,
            flex: 1,
            renderCell: (params) => renderOpenFile(params)
        },
        {
            field: "path",
            headerName: "Download",
            minWidth: 150,
            flex: 1,
            renderCell: (params) => renderDownloadButton(params)
        },
    ]

    return <>
        <Grid item xs={12} md={4}>
            <Paper sx={{p: 3, borderRadius: 0}}>
                <Box
                    sx={{
                        flex: 1,
                        overflowX: "auto",
                        width: "100%",
                        display: "block",
                    }}
                >
                    <DataGridTable
                        columns={columns}
                        rows={rows}
                        disableDeleteColumn
                        resetKey={`documentacao`}
                    />
                </Box>
            </Paper>
        </Grid>
    </>
}

TabelaDownloadArquivo.propTypes = {
    rows: PropTypes.array.isRequired,
}

export default TabelaDownloadArquivo